import React, { Component } from 'react';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import Footer2 from '../../Shared/Footer2';
import '../../../css/PreAdvise/PreadviseExcelDetails.css';
import download from '../../../Assets/TruckVisits/Assets/download.svg';
import data from '../../../Data/TruckVisits/PreadviseExelData.json';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';
class PreadviseExcelDetails extends Component {
    render() {
        return (
            <div class="caacsoutercolor">
                <MetaDecorator title={TitleDescription.preAdviseExcelDetailsPageTitle} description={TitleDescription.preAdviseExcelDetailsPageDescription} />
                <Header tilesFetched={() => { }} />
                <div class="caacsnofullPreExcelDetails">
                    <div id="caacsnobox1preexcelDetails">
                        <nav class="caacnononavbar">
                            <div className="arcaacnonavbarnameExcelDetail">
                                <small id="nonavc">Pre-advise Details</small>
                            </div>
                        </nav>
                        <hr class="hr1" />
                        <div class="arcaanotificationmaincardpreex">
                            <div class="caaoncsdivlow1preex">
                                <div class="csdivlow2">
                                    Truck Registration No.:
                                </div>
                                <div class="csdivlow2resno">
                                    {localStorage.getItem("truckBookingNoLS")}
                                </div>
                            </div>
                            {(data?.map((dataexel, index) => {
                                return (
                                    <div class="exeluploaddiv" id="displayindesktop">
                                        <div class="exeluploaddivin">
                                            <div class="exeluploaddivinrow">
                                                <div class="exeluploaddivcol1">
                                                    <small class="exeluploaddivcoltexth">Pre-advise excel uploaded</small>
                                                    <small class="exeluploaddivcoltextb">{dataexel?.PreadviseExcelUploaded}</small>
                                                </div>
                                                <div class="exeluploaddivcol2">
                                                    <small class="exeluploaddivcoltexth">Status</small>
                                                    {(dataexel?.Status === "Processed Successfully")
                                                        ?
                                                        <small class="exeluploaddivcoltextbgreen">{dataexel?.Status}
                                                            <img
                                                                src={download}
                                                                class="ml-3 mb-1" id=""
                                                                alt="" loading="lazy"
                                                            />
                                                        </small>
                                                        : ((dataexel?.Status === "Processed successfully with errors")
                                                            ?
                                                            <small class="exeluploaddivcoltextborenge">{dataexel?.Status}
                                                                <img
                                                                    src={download}
                                                                    class="ml-3 mb-1" id=""
                                                                    alt="" loading="lazy"
                                                                />
                                                            </small>
                                                            :
                                                            <small class="exeluploaddivcoltextbred">{dataexel?.Status}</small>
                                                        )}
                                                    <small class="exeluploaddivcoltextbl">{dataexel?.StatusMessage}</small>
                                                </div>
                                                <div class="exeluploaddivcol3">
                                                    {(dataexel?.TotalRowsProcessed === "") ? null :
                                                        <small class="exeluploaddivcoltexth">Total Rows Processed</small>
                                                    }
                                                    <small class="exeluploaddivcoltextb">{dataexel?.TotalRowsProcessed}</small>
                                                </div>
                                            </div>
                                            {(dataexel?.ErrorCount === "") ? null : <div class="exeluploaddivinrowlow2">
                                                <div class="exeluploaddivcol1">
                                                    {(dataexel?.ErrorCount === "") ? null :
                                                        <small class="exeluploaddivcoltexth">Error Count</small>
                                                    }
                                                    <small class="exeluploaddivcoltextb">{dataexel?.ErrorCount}</small>
                                                </div>
                                            </div>
                                            }
                                        </div>
                                    </div>);
                            }))}
                            {(data?.map((dataexel, index) => {
                                return (
                                    <div class="exeluploaddiv" id="displayintabletmobile">
                                        <div class="exeluploaddivin">
                                            <div class="exeluploaddivinrowtablet">
                                                <div class="exeluploaddivcol1">
                                                    <small class="exeluploaddivcoltexth">Pre-advise excel uploaded</small>
                                                    <small class="exeluploaddivcoltextb">{dataexel?.PreadviseExcelUploaded}</small>
                                                </div>
                                                <div class="exeluploaddivcol2">
                                                    <small class="exeluploaddivcoltexth">Status</small>
                                                    {(dataexel?.Status === "Processed Successfully")
                                                        ?
                                                        <small class="exeluploaddivcoltextbgreenouter">
                                                            <small class="exeluploaddivcoltextbgreen">{dataexel?.Status}</small>
                                                            <img
                                                                src={download}
                                                                class="ml-3 mb-1" id=""
                                                                alt="" loading="lazy"
                                                            />
                                                        </small>
                                                        : ((dataexel?.Status === "Processed successfully with errors")
                                                            ?
                                                            <small class="exeluploaddivcoltextborengeouter">
                                                                <small class="exeluploaddivcoltextborenge">{dataexel?.Status}</small>
                                                                <img
                                                                    src={download}
                                                                    class="ml-3 mb-1" id="downloadPreExcel"
                                                                    alt="" loading="lazy"
                                                                />
                                                            </small>
                                                            :
                                                            <small class="exeluploaddivcoltextbred">{dataexel?.Status}</small>
                                                        )}
                                                    <small class="exeluploaddivcoltextbl">{dataexel?.StatusMessage}</small>
                                                </div>
                                            </div>
                                            <div class={(dataexel?.TotalRowsProcessed === "") ? "exeltabletrowEmpty" : "exeltabletrow"}>
                                                <div class="exeluploaddivcol3">
                                                    {(dataexel?.TotalRowsProcessed === "") ? null :
                                                        <small class="exeluploaddivcoltexth">Total Rows Processed</small>
                                                    }
                                                    <small class="exeluploaddivcoltextb">{dataexel?.TotalRowsProcessed}</small>
                                                </div>
                                                {(dataexel?.ErrorCount === "") ? null : <div class="exeluploaddivinrowlow">
                                                    <div class="exeluploaddivcol1">
                                                        {(dataexel?.ErrorCount === "") ? null :
                                                            <small class="exeluploaddivcoltexth">Error Count</small>
                                                        }
                                                        <small class="exeluploaddivcoltextb">{dataexel?.ErrorCount}</small>
                                                    </div>
                                                </div>
                                                }
                                            </div>
                                        </div>
                                    </div>);
                            }))}
                        </div>
                    </div>
                </div>
                <div class="caanotifooter01ahzpreex">
                    <Footer />
                </div>
                <div class="caanotifooter02ahzpreex">
                    <Footer2 />
                </div>
            </div>
        );
    }
}
export default PreadviseExcelDetails;